// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Oea2m","block":"style_block__Njkej","icon":"style_icon__r_os0","text-block":"style_text-block__gp0Yx"};